/**
 * A note that this browser fetched an installer.
 *
 * <p>What remains of a larger module that also decided where a question typed
 * on the marketing site should be taken -- signed in, or download first. That
 * hero prompt was removed (a box that cannot answer is worse than no box), and
 * every reader of this value went with it. The write is kept because the
 * download page still makes it; nothing consumes it today.
 */

const DOWNLOADED_KEY = 'nevtan.downloadedAt'

/** Called when a download actually starts, not when the page is merely viewed. */
export function markDownloaded() {
  try {
    localStorage.setItem(DOWNLOADED_KEY, new Date().toISOString())
  } catch {
    // Private windows and blocked site data both throw. Nothing depends on the
    // record, so there is nothing to recover.
  }
}
